import echarts from "echarts/lib/echarts"
let chartInstanceMap = {}
let resizeFns = {}
let UA = navigator.userAgent
var client = {
  height: document.body.clientHeight,
  width: document.body.clientWidth,
}
function addEventOnResize(key, fn) {
  resizeFns[key] = fn
}

window.onresize = function() {
  client.height = document.body.clientHeight
  client.width = document.body.clientWidth
  for (let id in chartInstanceMap) {
    let c = chartInstanceMap[id]
    c && c.resize()
  }
  for (let k in resizeFns) {
    resizeFns[k] && resizeFns[k](client)
  }
}
//  做个全屏的构造函数
var FullScreen = function(elem) {
  this.elem = elem
}
//  全屏
FullScreen.prototype.in = function() {
  this.full = true
  if (this.elem.requestFullscreen) {
    this.elem.requestFullscreen()
  } else if (this.elem.webkitRequestFullscreen) {
    this.elem.webkitRequestFullscreen()
  } else if (this.elem.mozRequestFullScreen) {
    this.elem.mozRequestFullScreen()
  } else if (this.elem.msRequestFullscreen) {
    this.elem.msRequestFullscreen()
  }
}
//  退出全屏
FullScreen.prototype.out = function() {
  this.full = false
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen()
  }
}
FullScreen.prototype.toggle = function() {
  if (this.full) {
    this.out()
  } else {
    this.in()
  }
}
// const COLORS = [
//   "#3498db",
//   "#2dcb71",
//   "#e67f22",
//   "#745ec5",
//   "#e74d3c",
//   "#ffcd00",
//   "#ef717a",
//   "#a5c53a",
//   "#99aad3",
//   "#d5c295",
// ]
export default {
  isMobile: /(iphone)|(android)/gi.test(UA),
  addEventOnResize: addEventOnResize,
  /**
   * 注册图表自适应窗口
   * @param chartInstance
   */
  registerChartsResize: function(chartInstance) {
    chartInstanceMap[chartInstance.id] = chartInstance
    // ;(function () {
    //   let ps
    //   let current
    //   let myChart = chartInstance

    //   function setFocus (i, color) {
    //     ps = myChart.getDom().querySelectorAll('.echarts-tooltip-highlight')
    //     current = ps[0]
    //     if (current) {
    //       current.style.top = 26 + 21 * i + 'px'
    //       current.style.visibility = 'visible'
    //     }
    //   }

    //   myChart.on('mouseover', function (param) {
    //     setFocus(param.seriesIndex, param.color)
    //   })
    // })()
  },
  getChartsInstance: function() {
    return chartInstanceMap
  },
  /**
   * 取消注册图表自适应窗口
   * @param chartInstance
   */
  destroyCharts: function(chartInstance) {
    if (!chartInstance) {
      return
    }
    delete chartInstanceMap[chartInstance.id]
    echarts.dispose(chartInstance)
  },
  client,
  FullScreen,
}
